import { render, staticRenderFns } from "./EditBankInfo.vue?vue&type=template&id=2752e35a"
import script from "./EditBankInfo.vue?vue&type=script&lang=js"
export * from "./EditBankInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports